import * as React from 'react';
import { BackButton } from './components/BackButton';
import { ConfirmModal } from 'components/confirm-modal';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { General } from 'constants/validationMessages';
import { NotificationLink } from 'modules/navbar/components/NotificationBar/NotificationLink';

interface IPageHeaderProps {
	backButton?: boolean;
	children: React.ReactNode | React.ReactNodeArray;
	id?: string;
	confirmMessage?: string;
	displayConfirm?: boolean;
	showNotificationIcon?: boolean;
	notificationTarget?: string;
	notificationIndicator?: boolean;
	customMainClass?: string;
}
interface IProps extends IPageHeaderProps, RouteComponentProps { }
export const _PageHeader = (props: IProps) => {
	const [wasConfirmed, setConfirmation] = React.useState<boolean>(false);
	const [dialogVisible, setConfirmDialog] = React.useState<boolean>(false);
	const getButton = () => {
		if (wasConfirmed || !props.displayConfirm) {
			return <BackButton />;
		}
		else {
			return <BackButton isFake={true} callBack={() => { setConfirmDialog(true); }} />;
		}
	};
	return (
		<div className="header-group profile-template grid-wrapper" id={`page-header-${props.id}`}>
			<main className={props.customMainClass ? props.customMainClass : 'full-width'}>
				<ul className="page-title-group">
					{props.backButton ? getButton() : <li style={{ margin: 0 }} />}
					<li>
						<h1 id={props.id}>{props.children}</h1>

					</li>
					{props.showNotificationIcon &&
						<li style={{ display: 'inline-block', verticalAlign: 'top' }}> <NotificationLink
							notificationIndicator={props.notificationIndicator ? props.notificationIndicator : false}
							target={props.notificationTarget ? props.notificationTarget : ''} /></li>

					}
				</ul>

			</main>
			{dialogVisible && <ConfirmModal
				title="Are you sure?"
				visible={dialogVisible}
				onConfirm={() => { setConfirmDialog(false); setConfirmation(true); props.history.goBack(); }}
				closeModal={() => { setConfirmDialog(false); setConfirmation(false); }}
			>
				{props.confirmMessage ? props.confirmMessage : General.Alert_Abandon_Page}
			</ConfirmModal>}
		</div>
	);
};
export const PageHeader = withRouter(_PageHeader);